export default __webpack_public_path__ + "static/media/arrow_blue.ea311cf2.png";